import React  from 'react';
import { OkButton } from '../../shared/components/Buttons';
import {useTranslation} from "react-i18next";
import ScrollableElement from '../../shared/containers/ScrollableContainer'

const SubmitForm = ({ data, isLoading, isValid, areTermsReaded, onSubmit, onClickCancel,onBottomReached, onTermsAccepted }) => {
    const { t } = useTranslation()
    return <div className="flex-col-right booking-history">
        <div className="inner">
            <h1 className="col-right-title">{t('booking.validate_request')}</h1>

            <p>{t('booking.terms')}</p>
            <ScrollableElement onBottomReached={onBottomReached} className="scrollable-element">
                <article>
                    <em>CGV mise à jour le 1er mars 2022</em>
                    <h2 className="part-title">1. Acceptation des Conditions Générales de Vente</h2>
                    <hr className="title-sep"/>
                    <p>
                        Les présentes Conditions Générales de Vente régissent les relations contractuelles entre :
                    </p>
                    <ul>
                        <li>
                            La société <strong>La Malle Postale</strong><br/>
                            SARL au capital de 50 000 €, dont le siège est à Malpas - Rue du 11 novembre - 43370
                            Cussac sur Loire,
                            791 807 357 RCS LE PUY EN VELAY, N° de TVA Intracommunautaire FR 75510769623<br/>
                            Tél. 04 71 04 21 79 - Tél. 06 44 60 66 87<br/>
                            contact@lamallepostale.com<br/>
                            Nos bureaux sont situés au 11 avenue Charles Dupuy 43000 Le Puy-en-Velay et nous vous y
                            accueillons :
                            <ul>
                                <li>
                                    De mi-avril à mi-octobre : tous les jours de 7h30 à 12h puis de 14h à 19h00,
                                    sauf le dimanche (et jours fériés) de 16h à 19h00
                                </li>
                                <li>
                                    De mi-octobre à mi-avril : du lundi au vendredi (sauf jour férié) de 9h à 12h et
                                    de 14h à 18h
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <strong>et</strong>
                    <ul>
                        <li>
                            Le <strong>client de la société La Malle Postale</strong>.
                        </li>
                    </ul>
                    <p>
                        La demande de devis et/ou de réservation de la part du client engendre l'acceptation
                        de l'intégralité des présentes Conditions Générales de Vente.
                    </p>
                    <p>
                        Ces Conditions Générales de Vente prévaudront sur toutes autres conditions figurant dans
                        tout autre document,
                        sauf dérogation préalable, expresse et écrite.
                    </p>

                    <h3>Réservation</h3>

                    <p>
                        <strong>
                            Les services proposés par La Malle Postale fonctionnent uniquement sur réservation.
                            La demande de devis ne constitue pas une réservation.
                        </strong>
                    </p>
                    <p>
                        <strong>
                            Les services proposés par La Malle Postale peuvent être réservés à notre bureau, par
                            courriel,
                            par téléphone ou par le système de réservation en ligne de notre site internet
                            <a href="http://www.lamallepostale.com">www.lamallepostale.com</a> (ci-après le « site »
                            ou le « site internet »).
                        </strong>
                    </p>
                    <p>
                        <strong>
                            La réservation doit être demandée par le client et confirmée par nos équipes par
                            téléphone ou par courriel.
                        </strong>
                    </p>
                    <p>
                        <strong>
                            La réservation ne sera confirmée qu’après paiement de la prestation.<br/>
                            Le paiement de la prestation doit intervenir au plus tard 8 jours calendaires avant le
                            début de la prestation.
                            Toute prestation non réglée dans ces délais sera considérée comme non confirmée par le
                            client.
                            En cas de réservation via notre site internet, un courriel de confirmation sera
                            systématiquement envoyé par nos équipes.
                        </strong>
                    </p>
                    <p>
                        <strong>
                            En l’absence de réception du mail de confirmation au moins 24 heures avant votre départ,
                            votre demande de réservation n’est pas confirmée, et nous vous invitons dans ce cas à
                            prendre
                            directement contact avec nos équipes par téléphone.
                        </strong>
                    </p>
                    <p>
                        <strong>
                            Aucune réservation ne sera prise en compte par message téléphonique.
                        </strong>
                    </p>
                    <p>
                        <strong>
                            Les services fournis par La Malle Postale sont proposés dans la limite des véhicules de
                            transport
                            et des chauffeurs disponibles <span style={{"textDecoration": "underline"}}>au jour du paiement de la réservation</span>.
                        </strong>
                    </p>
                    <p>
                        <strong>
                            Pour toute question n’hésitez pas à nous contacter ou à consulter la FAQ de notre site.
                        </strong>
                    </p>
                </article>
                <article>
                    <h2 className="part-title">2. Les services</h2>
                    <hr className="title-sep"/>

                    <h3>2.0. Assurances – réglementation applicable</h3>
                    <p>
                        Pour ses activités, La Malle Postale a souscrit une assurance couvrant sa responsabilité
                        civile professionnelle
                        auprès de la compagnie AXA France IARD François ISSARTEL -
                        5 place Michelet 43000 Le Puy en Velay - 04.71.05.53.10. Police N° 5036002804.
                    </p>
                    <p>
                        La société La Malle Postale exerce une activité de transport de marchandises et de voyageurs
                        réglementée.
                        Elle est inscrite sur le registre des transporteurs de voyageurs et marchandises tenu
                        par le préfet du département de la Haute-Loire et géré par la DREAL,
                        et est titulaire des licences nécessaires à son activité.
                        Vous pourrez retrouver toutes les informations utiles concernant cette réglementation sur le
                        site :
                        <a href="https://www.ecologique-solidaire.gouv.fr/acces-et-exercice-profession-transporteur-marchandises-0">https://www.ecologique-solidaire.gouv.fr/acces-et-exercice-profession-transporteur-marchandises-0</a>.
                    </p>
                    <p>
                        Pour la réalisation des services proposés, La Malle Postale se réserve le droit de
                        sous-traiter
                        la prestation auprès de professionnels qu’elle aura sélectionnés.
                        En cas de sous-traitance, vous en serez informés et nous vous communiquerons le nom du
                        sous-traitant concerné à votre demande.
                        La Malle Postale restera votre interlocuteur.
                    </p>
                    <p>
                        Les services proposés par La Malle Postale sont ceux listés ci-dessous à l’exclusion de tous
                        autres services.
                        Le client demeure seul responsable de sa réservation d’hébergement.
                    </p>

                    <h3>2.1. Le service de transport de personnes et navettes régulières</h3>
                    <p>
                        Le service transport de personnes de La Malle Postale consiste en la mise à votre
                        disposition de véhicules,
                        type "minibus" ou autre (en cas de forte demande, La Malle Postale se réserve le droit de
                        faire appel à un autocariste)
                        avec chauffeur afin de vous permettre :
                    </p>
                    <ul>
                        <li>de revenir à votre point de départ à la fin de votre parcours,</li>
                        <li>d’être transporté à votre prochaine étape en cas de fatigue ou de blessure ou autre,
                        </li>
                        <li>de rejoindre une gare ou tout autre destination grâce à notre service de transport sur
                            mesure.
                        </li>
                    </ul>
                    <p>
                        La réservation auprès de nos équipes vous permet de réserver la date,
                        l’heure et le lieu de votre prise en charge par le chauffeur, ainsi que l’heure et le lieu
                        de dépose.
                        Les horaires seront confirmés lors de la confirmation de votre réservation par nos équipes.
                    </p>
                    <p>
                        Afin de vous offrir le meilleur service, il est impératif lors de la réservation de préciser
                        le nombre de bagages
                        (ou de vélos le cas échéant) qui seront également à transporter.
                        En présence de bagages, ils demeurent dans ce cas sous la garde et la responsabilité des
                        personnes transportées.
                    </p>
                    <p>
                        Le service transport de personnes de La Malle Postale permet également le transport de votre
                        chien.<br/>
                        Afin de déterminer les conditions de ce transport, nous vous invitons à prendre directement
                        contact par téléphone
                        ou par courriel avec nos équipes. Afin de vous offrir le meilleur service,
                        il est impératif lors de la réservation de préciser la présence du chien également à
                        transporter.
                        Pour tout transport de chien, l’animal demeure sous la seule garde et la seule
                        responsabilité de la personne transportée qu’il accompagne.
                    </p>
                    <p>
                        Pour les chemins de Saint-Jacques de Compostelle, de Stevenson et de St Guilhem,
                        La Malle Postale vous propose également un service de navettes régulières.
                        Elles permettent aux randonneurs de se déplacer d'une étape à une autre sur un chemin de
                        randonnée, pour :
                    </p>
                    <ul>
                        <li>revenir à son point de départ,</li>
                        <li>rejoindre son véhicule.</li>
                    </ul>
                    <p>Plusieurs départs par jour, départs à horaires fixes et réguliers sur réservation.</p>


                    <h3>2.2. Le service de transport de bagages</h3>
                    <p>
                        Le service transport de bagages de La Malle Postale consiste à prendre votre bagage
                        au lieu convenu ensemble et à le transporter dans la journée jusqu'à votre lieu de couchage
                        ou en tout autre lieu convenu ensemble.
                        Le service peut ainsi être reproduit tous les jours d’étape en étape jusqu'à la fin de votre
                        parcours,
                        dans la limite des zones desservies par La Malle Postale.
                    </p>
                    <p>
                        La réservation auprès de nos équipes ou sur le site internet de La Malle Postale vous permet
                        de réserver
                        la date et le lieu de la prise en charge de vos bagages par nos services,
                        ainsi que le lieu de dépose.
                        Lors de la réservation il est impératif de préciser le nombre de bagages à transporter.
                    </p>
                    <p>
                        Le client s’engage à informer les responsables du lieu d’enlèvement ou de dépose de son
                        bagage
                        que celui-ci sera enlevé ou retiré par La Malle Postale.
                    </p>
                    <p>Le bagage peut être soit une valise, soit un sac de sport ou encore un sac à dos.</p>
                    <p>
                        Le bagage doit avoir un poids maximum de 13kg, être en bon état, fermé et en un seul
                        volume.<br/>
                        Tout sac ou équipement supplémentaire est considéré comme un bagage supplémentaire et sera
                        facturé comme tel.
                    </p>
                    <p>
                        En cas de surpoids, La Malle Postale demandera au client de faire le nécessaire pour
                        respecter la limite de 13kg.
                        Cela passera éventuellement par le transport d’un bagage supplémentaire au tarif en vigueur
                        qui vous a été communiqué pour votre premier bagage.
                        Un sac pourra vous être fourni par La Malle Postale pour constituer ce bagage
                        supplémentaire, dès le lendemain, sur simple demande.<br/>
                        Le bagage à transporter doit être mis à disposition de nos services à 8h00 dans la bagagerie
                        de votre hébergement
                        ou tout autre endroit prévu par l’hébergement. Il vous sera remis au lieu d’hébergement
                        indiqué par vous avant 18 heures.
                        En cas d’absence il sera déposé dans la bagagerie de celui-ci ou dans tout autre endroit
                        réservé à cet usage par le lieu d’hébergement.
                    </p>
                    <p>
                        Le bagage à transporter doit être clairement identifié au moyen d'un papier libre portant
                        clairement les mentions ci-dessous :
                    </p>
                    <ul>
                        <li>Mention : LA MALLE POSTALE,</li>
                        <li>Votre nom et prénom,</li>
                        <li>Votre n° de téléphone portable,</li>
                        <li>le nombre de sacs à transporter (si vous êtes en groupe notamment).</li>
                    </ul>
                    <p>
                        ou au moyen de nos étiquettes dûment complétées disponibles dans les hébergements ou
                        téléchargeable ici
                        (<a
                        href="http://www.lamallepostale.com/_download/etiquettesLMP.pdf">http://www.lamallepostale.com/_download/etiquettesLMP.pdf</a>).
                    </p>
                    <p>
                        Tout bagage non identifié clairement ne sera pas transporté et le client demeurera
                        responsable de son bagage.
                    </p>
                    <p>
                        La Malle Postale est responsable du bagage durant le transport.
                        Le client demeure responsable de son bagage, notamment en cas de vol ou dégradation sur le
                        lieu d'hébergement,
                        le lieu d’enlèvement ou de dépose, et notamment dans la bagagerie de ce lieu (enlèvement ou
                        dépose).
                    </p>
                    <p>
                        Le client s’engage à ce que son bagage ne contienne pas d'objet de valeur (supérieure à 50
                        €), d’objet fragile ou de médicaments.
                    </p>
                    <p>
                        En cas de bagage contenant des objets de valeur ou particulièrement fragiles,
                        nous vous invitons à le déclarer à nos équipes avant le transport afin que les dispositions
                        nécessaires puissent être prises.
                    </p>
                    <p>
                        Le service transport de bagages de La Malle Postale permet également le transport de vélo(s)
                        sur certains itinéraires.
                        La disponibilité de ce service spécifique et les tarifs associés sont indiqués sur la fiche
                        itinéraire
                        de chaque chemin sur notre site internet.<br/>
                        La réservation du transport de vélo(s) doit être mentionnée expressément auprès de nos
                        équipes ou sur le site internet.
                    </p>

                    <h3>2.3. Le service de convoyages de véhicules</h3>
                    <p>
                        Le service de convoyage de véhicules est disponible sur les chemins de Saint-Jacques de
                        Compostelle
                        (uniquement sur la partie Le Puy-en-Velay – Moissac) et Stevenson.
                    </p>
                    <p>
                        Le service est disponible pour une distance minimum de 70km entre le point de prise en
                        charge et le point de dépose du véhicule.
                    </p>
                    <p>
                        Le service de convoyage de véhicule de La Malle Postale consiste à prendre en charge votre
                        véhicule
                        au point de départ de votre parcours et de le conduire à votre point d'arrivée.
                    </p>
                    <p>
                        La conclusion du contrat et la finalisation de la commande de prestation de convoyage sont
                        soumises à la signature préalable du
                        « contrat de prestation de convoyage de véhicule » et de l’état des lieux du véhicule le
                        jour de la remise des clés.
                    </p>
                    <p>
                        Le site de réservation en ligne de La Malle Postale vous permet de réserver la date et le
                        lieu de la prise en charge
                        de votre véhicule ainsi que la date ultime et le lieu de dépose de votre véhicule.
                    </p>
                    <p>
                        Le véhicule à convoyer devra bénéficier d’une assurance en cours de validité souscrite pour
                        « tous conducteurs ».
                        Le client demeure seul responsable du vol ou de tous autres dommages pouvant affecter le
                        Véhicule
                        et les éventuels biens qu'il contient, notamment lors du stationnement du Véhicule sur les
                        aires de stationnement privées ou publiques.
                    </p>

                    <h3>2.4. Location de minibus sans chauffeur</h3>
                    <p>
                        Le service de location de minibus est disponible uniquement au départ du Puy-en-Velay. Le
                        véhicule devra être restitué au même endroit.
                    </p>
                    <p>
                        La Malle Postale propose un service de location de véhicules (type mini-bus jusqu’à 9
                        personnes) pour vos déplacements de groupe.
                        La conclusion du contrat et la finalisation de la location sont soumises à la signature
                        préalable du
                        « contrat de location de véhicule sans chauffeur » et de l’état des lieux du véhicule le
                        jour de la remise des clés.
                        Le client devra fournir l’ensemble des justificatifs nécessaires à la conclusion du contrat
                        de location (permis de conduire etc).
                    </p>
                    <p>
                        Vous pouvez réserver votre location en prenant contact directement avec nos services.
                    </p>

                    <h3>2.5. Stationnement de votre véhicule</h3>
                    <p>
                        Pour les clients qui profitent de nos retours en navette exclusivement,
                        nous proposons des places de stationnement de votre véhicule pour les départs du
                        Puy-en-Velay.
                    </p>
                    <p>
                        Notre parking est situé à 7km de nos bureaux du Puy. Vous pouvez réserver votre place en
                        prenant contact avec nos services.
                        Vous pourrez déposer votre véhicule directement sur notre plateforme de stationnement privée
                        située au lieu-dit Malpas,
                        commune de Cussac-sur-Loire. Vous serez ensuite ramené au Puy-en-Velay grâce à une navette.
                    </p>
                    <p>
                        A la fin de votre randonnée, notre navette vous ramènera directement sur notre plateforme de
                        stationnement.
                    </p>
                </article>
                <article>
                    <h2 className="part-title">3. Zone – Fonctionnement de la centrale de réservations en ligne</h2>
                    <hr className="title-sep"/>
                    <p>
                        Les lieux desservis par La Malle Postale sont exclusivement les lieux d’hébergement suivants
                        :
                        gîtes, campings, hôtels et chambres d’hôtes, à l’exclusion de tout autre lieu.
                    </p>
                    <p>
                        La réservation en ligne est possible pour les services suivants :
                        transport de bagage – navette régulière – convoyage de véhicule – transport de vélos.
                    </p>
                    <p>
                        Pour les autres services, nous vous remercions de nous contacter directement par courriel ou
                        par téléphone.
                    </p>

                    <p>
                        La liste des parcours couverts par nos services est consultable sur notre site à l'adresse :
                        <a href="https://www.lamallepostale.com/fr/itineraires">www.lamallepostale.com/fr/itineraires</a>
                    </p>
                    <p>
                        Les parcours couverts sont détaillés avec l’ensemble des étapes où nos services sont
                        disponibles
                        sur la page internet du parcours concerné.
                        La Malle Postale se réserve le droit à tout moment et sans préavis d'ajouter ou de supprimer
                        des parcours,
                        ou des étapes dans les parcours (sauf réservation confirmée).
                    </p>
                    <p>
                        Pour toute intervention hors de ces parcours, nous vous remercions de prendre contact
                        directement avec nos équipes.
                    </p>
                    <p>
                        Lorsque la réservation en ligne est possible et afin de permettre la réservation de la
                        prestation
                        sur notre site et la conclusion du contrat, vous devez :
                    </p>
                    <ul>
                        <li>
                            <strong>Etape 1</strong> : vous connecter à votre compte si vous en possédez déjà un ;
                            le cas échéant renseigner l’ensemble des champs relatifs à la création de votre compte et
                            accepter les
                            Conditions Générales de Vente.
                        </li>
                        <li>
                            <strong>Etape 2</strong> : demander un devis en sélectionnant la prestation choisie,
                            puis en entrant vos dates,
                            lieux de réservation, nombre de personnes, de bagages, de vélos ou de voitures, puis
                            valider ses éléments en cliquant sur le bouton « suivant ».
                        </li>
                        <li>
                            <strong>Etape 3</strong> : vérifier vos données, lire et accepter les Conditions
                            Générales de Vente et
                            cliquer sur le bouton « Je valide ma demande » pour permettre l'envoi de votre demande
                            de devis.
                        </li>
                    </ul>
                    <p>
                        Un récapitulatif des services sélectionnés avec le prix afférent vous sera envoyé par
                        courriel à réception de votre demande.
                    </p>
                    <p>
                        Vous pouvez ensuite procéder au paiement en ligne ou retarder votre paiement jusqu’à 8 jours
                        avant votre départ comme indiqué à l’article 5 ci-dessous.
                    </p>
                    <p>
                        L’enregistrement de la demande de réservation implique l'acceptation de l'intégralité des
                        présentes Conditions Générales de Vente.
                        Les données enregistrées par le système informatique de La Malle Postale constituent la
                        preuve
                        des transactions passées sur le site entre La Malle Postale et ses clients.
                        Pour accéder à une copie de la transaction, merci d’adresser votre demande à
                        contact@lamallepostale.com.
                    </p>
                    <p>
                        En cas de demande de réservation sans paiement, La Malle Postale confirme votre demande de
                        réservation
                        par un courriel récapitulant votre demande de réservation.
                    </p>
                    <p>
                        En cas de paiement, La Malle Postale confirme l'acceptation de votre réservation par un
                        courriel récapitulant votre réservation
                        ainsi que son paiement à l'adresse email que vous avez indiquée.
                    </p>

                </article>

                <article>
                    <h2 className="part-title">4. Tarifs</h2>
                    <hr className="title-sep"/>
                    <p>
                        L’ensemble de nos tarifs sont disponibles dans chacune des fiches de prestations et sur
                        devis pour votre prestation personnalisée.<br/>
                        Les prix sont exprimés en Euros.
                    </p>
                    <p>
                        Les prix indiqués incluent la TVA au taux fixé par les réglementations en vigueur,
                        le carburant pour les prestations de transport uniquement et les assurances nécessaires.
                    </p>
                    <p>
                        Le prix total indiqué dans le récapitulatif de la réservation est le prix définitif,
                        sauf nouvel élément le jour de la prestation : bagage(s) supplémentaire(s), surpoids de
                        bagage(s), bagage(s) demandant un maniement ou un soin spécifique.
                        Ce prix comprend le prix total pour la ou les prestations réservées avec le détail de chaque
                        prestation.
                    </p>
                    <p>
                        La Malle Postale se réserve le droit de modifier ses tarifs à tout moment, à l’exclusion des
                        tarifs des prestations déjà réservées.
                    </p>
                </article>

                <article>
                    <h2 className="part-title">5. Moyens et modalités de paiement</h2>
                    <hr className="title-sep"/>
                    <p>
                        Les modes de paiement suivants sont acceptés : Espèces, chèques, virements bancaires, cartes
                        bancaires (Visa et Master Card).
                    </p>
                    <p>
                        Les prestations sont payables au plus tard 8 jours calendaires avant le début de la
                        prestation.
                        Aucune prestation n’est réservée définitivement avant le paiement.
                        En l’absence de paiement 10 jours calendaires avant le début de la prestation demandée, un
                        courriel de rappel vous sera transmis.
                        Le paiement de la prestation devra intervenir dans les 48 heures de ce courriel.<br/>
                        Toute demande de prestation non réglée dans ces délais sera considérée comme non confirmée
                        par le client et annulée.
                    </p>
                    <p>
                        Dans le cadre d'un paiement par Carte Bancaire ou virement, la réservation n'est considérée
                        comme confirmée
                        qu'à compter de l'acceptation du paiement ou du virement et de la confirmation de la
                        réservation par La Malle Postale.
                    </p>
                    <p>
                        Dans le cadre d'un paiement par chèque bancaire, la réservation n’est considérée comme
                        confirmée
                        qu'à compter de l’encaissement du chèque de règlement par La Malle Postale et de la
                        confirmation de la réservation par La Malle Postale.<br/>
                        Le client devra poster ou remettre son chèque de règlement à l'adresse :
                        La Malle Postale, 11 avenue Charles Dupuy 43000 Le Puy-en-Velay. Le chèque devra être émis à
                        l'ordre de La Malle Postale.
                    </p>
                    <p>
                        La Malle Postale se réserve le droit de refuser ou d'annuler toute nouvelle réservation
                        venant d'un client avec lequel un litige existe.
                    </p>
                </article>

                <article>
                    <h2 className="part-title">6. Modalités et frais d’annulation – Droit de rétractation</h2>
                    <hr className="title-sep"/>
                    <p>
                        Le client dispose d'un délai de quatorze (14) jours à compter du paiement de la prestation
                        pour exercer son droit de rétractation sauf si la prestation a été pleinement exécutée
                        avant la fin du délai de rétractation et que le client a, préalablement à l’exécution du
                        service,
                        expressément renoncé à son droit de rétractation. Si la totalité du service n’est pas
                        exécuté,
                        le client verse au professionnel un montant correspondant au service fourni
                        jusqu'à la communication de sa décision de se rétracter.
                    </p>
                    <p>
                        Sans préjudice du délai de rétractation lorsqu’il est applicable,
                        toute réservation peut faire l’objet d’une annulation par courriel ou par téléphone,
                        sans justification par le client dans les conditions suivantes :
                    </p>
                    <ul>
                        <li>Au moins 48 h avant la réalisation de la prestation : sans indemnité</li>
                        <li>24 h avant la réalisation la prestation : indemnité due par le client à La Malle Postale
                            à hauteur de 50 % du prix du service commandé
                        </li>
                        <li>à moins de 24 h de la réalisation de la prestation : indemnité due par le client à La
                            Malle Postale à hauteur de 100 % du prix du service commandé
                        </li>
                    </ul>

                    <p>
                        Suivant les conditions d’annulation indiquées ci-dessus, les remboursements éventuels
                        interviendront selon le même mode de paiement utilisé par le client,
                        sauf accord du client pour tout autre mode. Le client fournira toutes les données
                        nécessaires au service de La Malle Postale.
                    </p>
                    <p>
                        Pour tout remboursement, des frais à hauteur de 5€ seront retenus sur le compte du client.
                    </p>

                    <p>
                        Toute réservation peut faire l’objet d’une annulation sans justification par nos services
                        dans les conditions suivantes :
                    </p>
                    <ul>
                        <li>Au moins 48 h avant la réalisation de la prestation : restitution des sommes perçues
                            sans indemnité
                        </li>
                        <li>
                            24 h avant la réalisation la prestation :
                            restitution des sommes perçues et indemnité due au client équivalente à 50 % du prix du
                            service commandé
                        </li>
                        <li>
                            à moins de 24 h de la réalisation de la prestation:
                            restitution des sommes perçues et indemnité due au client équivalente à 100 % du prix du
                            service commandé
                        </li>
                    </ul>
                    <p>
                        Une modification de la prestation par La Malle Postale permettant de répondre
                        à la demande du client ne pourra pas être considérée comme une annulation de la prestation
                    </p>

                </article>
                <article>
                    <h2 className="part-title">7. Force majeure</h2>
                    <hr className="title-sep"/>
                    <p>
                        La Malle Postale ne pourra être tenue pour responsable, ou considérée comme ayant failli à
                        ses obligations,
                        pour tout retard ou inexécution lorsque la cause du retard ou de l'inexécution résulte
                        d’un cas de force majeure tel que défini par la jurisprudence des tribunaux français.
                        En complément et au sens du présent contrat, l’empêchement du Prestataire pour cause
                        d’intempéries,
                        grèves, travaux de voirie, densité de circulation et accidents routiers, et tous évènements
                        échappant raisonnablement au contrôle de La Malle Postale, seront notamment considérée comme
                        cas de Force Majeure.
                    </p>
                    <p>
                        En cas de force majeure, La Malle Postale informera le client dans les meilleurs délais
                        et fera ses meilleurs efforts afin de satisfaire ses obligations
                        mais elles pourront être retardées ou annulées sans indemnité.
                    </p>
                </article>

                <article>
                    <h2 className="part-title">8. Loi applicable – langue du contrat</h2>
                    <hr className="title-sep"/>
                    <p>
                        Les présentes conditions générales d’intervention sont rédigées en langue française.
                        Elles sont soumises à la Loi Française.
                        Le fait pour La Malle Postale ou le client de ne pas se prévaloir à un moment donné de l'une
                        quelconque
                        des clauses des présentes ne peut valoir renonciation à se prévaloir ultérieurement de ces
                        mêmes clauses.
                    </p>
                </article>

                <article>
                    <h2 className="part-title">9. Réclamations</h2>
                    <hr className="title-sep"/>
                    <p>
                        Toutes réclamations ou questions peuvent être adressées par courrier à la société La Malle
                        Postale
                        11 avenue Charles Dupuy 43000 Le Puy en Velay, par téléphone au 04 71 04 21 79,
                        ou par mail à l’adresse contact@lamallepostale.com.
                    </p>
                </article>
                <article>
                    <h2 className="part-title">10. Litiges - médiation a la consommation</h2>
                    <hr className="title-sep"/>
                    <p>
                        En cas de litige entre La Malle Postale et le client, une solution amiable devra être
                        privilégiée avant toute action en justice.
                    </p>
                    <p>
                        En cas de contestation avec La Malle Postale, le client pourra recourir gratuitement
                        au service de médiation du CNPM MEDIATION CONSOMMATION, par voie électronique :
                        <a href="https://www.cnpm-mediation-consommation.eu/">https://www.cnpm-mediation-consommation.eu/</a>,
                        courriel : cnpm@orange.fr, courrier : 23 rue de Terrenoire 42100 Saint-Etienne, tél. : 04 77
                        49 45 89.
                    </p>
                    <p>
                        En l'absence d'accord entre les parties, le litige pourra être porté devant le tribunal
                        compétent.
                    </p>
                    <p>
                        Il est rappelé que le recours à la médiation n'est possible qu'à la condition que la
                        réclamation
                        n'ait pas été au préalable examinée par un juge ou un autre médiateur et sous réserve
                        d’avoir tenté
                        au préalable de résoudre le litige directement auprès de La Malle Postale par une
                        réclamation écrite.
                        La demande de médiation doit intervenir dans les 12 derniers mois de la réclamation écrite.
                        La médiation interrompt la prescription.
                    </p>
                    <p>
                        Le client peut également consulter le site de la plateforme de règlement des litiges à
                        l’adresse suivante :
                        <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=FR">
                            https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=FR
                        </a>
                    </p>
                </article>

                <article>
                    <h2 className="part-title">11. Protection des données personnelles</h2>
                    <hr className="title-sep"/>
                    <p>
                        Les données personnelles collectées auprès du client sont nécessaires à l’exécution de la
                        prestation
                        et à l’établissement de la facture correspondante.
                    </p>
                    <p>
                        Les données personnelles du client sont collectées via le site internet ou directement
                        auprès
                        de nos services et elles sont susceptibles de faire l’objet d’un traitement informatique
                        destiné à :
                    </p>
                    <ul>
                        <li>
                            effectuer les opérations relatives à la gestion des clients concernant :
                            la réalisation des prestations; les factures; la comptabilité et en particulier la
                            gestion des comptes clients ;
                        </li>
                        <li>l’envoi de notre newsletter contenant l’information sur nos actualités ;</li>
                        <li>l’élaboration de statistiques commerciales et/ou afin de permettre l’évolution du
                            contenu de nos prestations;
                        </li>
                        <li>
                            le suivi de la relation client et de la situation du client, la réalisation d'enquêtes
                            de satisfaction,
                            la gestion des réclamations et des questions ultérieures éventuelles des clients ;
                        </li>
                        <li>la gestion des demandes relatives à vos droits concernant le traitement de vos données
                            personnelles ;
                        </li>
                        <li>la gestion des impayés et du contentieux;</li>
                        <li>la gestion des avis des personnes sur les services proposés.</li>
                    </ul>
                    <p>
                        Les informations nominatives collectées sont nécessaires au traitement de vos demandes.
                    </p>
                    <p>
                        Le destinataire des données est La Malle Postale ainsi que ses sous-traitants pour
                        l’exécution d’un service
                        (taxi, service de transport…) Ce sous-traitant est indiqué au client lors de la réservation
                        du service concerné.
                        La durée de conservation des données est limitée à la durée nécessaire aux opérations
                        pour lesquelles elles ont été collectées ainsi que dans le respect de la réglementation.
                        A cet égard, les données clients sont conservées pendant la durée des relations
                        contractuelles augmentées de cinq (5) ans,
                        sans préjudice des obligations de conservation ou des délais de prescription.
                    </p>
                    <p>
                        Conformément à la réglementation, vous bénéficiez d’un droit d’accès, de rectification,
                        d’effacement, de limitation du traitement, et d’un droit à la portabilité, des informations
                        qui vous concernent
                        et que vous pouvez exercer en vous adressant au responsable du traitement :
                    </p>
                    <p>
                        Madame Nadine OLLIER,<br/>
                        Par courrier : société La Malle Postale, 11 Avenue Charles Dupuy 43000 LE PUY EN VELAY<br/>
                        Par téléphone : 04.71.04.21.79<br/>
                        Par courriel : contact@lamallepostale.com
                    </p>
                    <p>
                        Vous disposez de la faculté de retirer à tout moment votre consentement sur le traitement de
                        vos données.
                    </p>
                    <p>
                        L’exigence de fourniture de vos données a un caractère purement contractuel et conditionne
                        l’exécution de la prestation.
                        Le client peut s’opposer, sans frais et sans justification, aux traitements des données qui
                        le concernent.
                        Cette opposition, comme le défaut de renseignement d’une information obligatoire (marquée
                        d’un signe* dans le formulaire de collecte),
                        entraînera le cas échéant une impossibilité de traiter les demandes du client.
                        Les données ne font pas l’objet de prise de décision automatisée et notamment de profilage.
                        En cas de réclamation concernant le traitement de vos données, vous pouvez vous adresser à
                        l’autorité de contrôle compétente.
                    </p>
                </article>
            </ScrollableElement>

            <div title="Vous devez lire toutes les CGV" className={!areTermsReaded ? 'disabled' : ''}>
                <input id="terms" type="checkbox" value="ok" disabled={!areTermsReaded} onChange={onTermsAccepted}/>
                <label htmlFor="terms">{t('booking.accept_terms')}</label>
            </div>

            <div className="dark-orange-action-buttons">
                <OkButton
                    type="button"
                    disabled={isLoading || !isValid}
                    loading={isLoading}
                    className="btn-primary btn-lg btn-warning"
                    onClick={onSubmit}
                >
                    {t('booking.validate_my_request')}
                </OkButton>

                {t('booking.or')} <a className="backlink" href="#" onClick={onClickCancel}>{t('booking.cancel')}</a>
            </div>

            <br/>
            <p>{t('booking.validate_request_information_1')}</p>
        </div>
    </div>
};

export default SubmitForm;
